var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-data-grid',{staticClass:"formGrid",attrs:{"show-column-headers":_vm.header,"data-source":_vm.dataSource,"columns":_vm.columns,"show-borders":true,"editing":_vm.editing}})}
var staticRenderFns = []

export { render, staticRenderFns }